// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-left-s"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13.2655 15.5355L9.72998 12L13.2655 8.46445","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronLeftSIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-left-s',
    ref,
    icon: element,
  },
));

ChevronLeftSIcon.displayName = 'ChevronLeftSIcon';

export default ChevronLeftSIcon;
